import { FormReviewData, PharmacyAction } from "@/types";
import { formatDateTime } from "@/utils/formatters";

interface NotesSectionProps {
  formData: FormReviewData;
}

export function NotesSection({ formData }: NotesSectionProps) {
  const notes =
    formData.pharmacyActions?.filter(
      (action) => action.type === "form_note_added"
    ) || [];

  if (notes.length === 0) return null;

  return (
    <div className="existing-notes-section">
      <div className="notes-header">
        <h3>Review Notes ({notes.length})</h3>
      </div>
      <div className="notes-list">
        {notes
          .sort(
            (a, b) =>
              new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
          )
          .map((note, idx) => {
            const performedByName =
              typeof note.performedBy === "object"
                ? note.performedBy.name || note.performedBy.email || "Unknown"
                : note.performedBy || "Unknown";

            const noteContent =
              typeof note.details === "string"
                ? note.details
                : note.details?.note || "No content";

            return (
              <div key={idx} className="note-item">
                <div className="note-content">{noteContent}</div>
                <div className="note-meta">
                  <span className="note-author">{performedByName}</span>
                  <span className="note-date">
                    {formatDateTime(note.timestamp)}
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
